import React from 'react';
import { Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';

const EinbeinstandErgebnisInput = (props) => {
    const style = {
        display: 'block ruby',
        padding: '10px'
    };
    return (
        <div>
            <div style={style}>
                <h5 style={style}>Links: </h5>
                <InputGroup className="w-25">
                    <Button onClick={() => props.onChange(1, props.EinbeinstandErgebnis[0] - 1)}>-</Button>
                    <Input type="number" id="versuch1Input" value={props.EinbeinstandErgebnis[0]} onChange={(e) => props.onChange(1, e.target.value)} />
                    <Button onClick={() => props.onChange(1, props.EinbeinstandErgebnis[0] + 1)}>+</Button>
                </InputGroup>
                <h5 style={style}>Mal den Fuß abgesetzt</h5>
            </div>
            <div style={style}>
                <h5 style={style}>Rechts: </h5>
                <InputGroup className="w-25">
                    <Button onClick={() => props.onChange(2, props.EinbeinstandErgebnis[1] - 1)}>-</Button>
                    <Input type="number" id="versuch1Input" value={props.EinbeinstandErgebnis[1]} onChange={(e) => props.onChange(2, e.target.value)} />
                    <Button onClick={() => props.onChange(2, props.EinbeinstandErgebnis[1] + 1)}>+</Button>
                </InputGroup>
                <h5 style={style}>Mal den Fuß abgesetzt</h5>
            </div>
        </div>
    );
};

export default EinbeinstandErgebnisInput;